<div [ngClass]="{
    'lupino-not-published':
    !isMyCharacterPage && isAdmin && !character.isPublic
  }"
	 class="card lupino-character-card h-100"
>

	<div class="lupino-card-img-container">
		<img
			[alt]="'Image de ' + character.name"
			[src]="character.imageUrl || '/lupino-placeholder-230h.png'"
			class="card-img-top lupino-character-img" />

		@if (!isMyCharacterPage && isAdmin && !character.isPublic) {
			<div class="lupino-unpublished-badge">
				<i class="fas fa-eye-slash"></i> Non publié
			</div>
		}
	</div>

	<div class="card-body lupino-card-body d-flex flex-column">
		<div class="card-decoration">
			<span></span>
			<i>◆</i>
			<span></span>
		</div>
		<h5 class="card-title lupino-character-name">
			{{ character.name }}
		</h5>

		<h6 class="lupino-character-owner">
			créateur : <span>{{ character.owner?.name || 'Compte supprimé' }}</span>
		</h6>

		<div class="lupino-character-stats">
			<div class="lupino-stat-row">
				<span class="lupino-stat-label">Level</span>
				<span class="lupino-stat-value">{{ character.level }}</span>
			</div>

			<div class="lupino-stat-row">
				<span class="lupino-stat-label">Race</span>
				@if (character.race) {
					<span class="lupino-stat-value">{{ character.race }}</span>
				}
				@if (character.lineage) {
					@if (character.lineage.kind == "pure") {
						<span class="lupino-stat-value">{{ raceMap.get(character.lineage.raceId) }}</span>
					}
					@if (character.lineage.kind == "hybrid") {
						@for (raceId of character.lineage.parentRaceIds; track raceId) {

							<span class="lupino-stat-value">{{ raceMap.get(raceId) }}</span>
						}
					}
				}
			</div>
		</div>

		<div class="mt-auto lupino-card-actions">
			<a
				[routerLink]="['/character', character._id]"
				class="btn lupino-view-btn w-100 mb-2">
				<i class="fas fa-eye me-2"></i>
				Voir la fiche
			</a>

			@if (isMyCharacterPage || isMyPnjPage) {
				<button
					class="btn lupino-delete-btn w-100"
					(click)="onDelete()">
					<i class="fas fa-trash me-2"></i>
					Supprimer
				</button>
			}
		</div>

		<div class="card-footer-decoration"><span>❧</span>
		</div>

	</div>
</div>
